import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import ThemeSwitcher from './ThemeSwitcher';

/**
 * Preferences: theme + jump to notification settings tab.
 */
export default function AccountPreferencesDialog({ open, onClose, onOpenNotifications }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Preferences</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Choose a color theme for the app. Notification delivery settings live on the Notifications page.
        </Typography>
        <ThemeSwitcher variant="inline" />
        <Box sx={{ mt: 3 }}>
          <Button
            variant="outlined"
            onClick={() => {
              onOpenNotifications?.();
              onClose();
            }}
          >
            Open notification settings
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
